
<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.375 12.2411V2.0835L9.38071 1.99869C9.42209 1.69362 9.68359 1.4585 10 1.4585C10.3452 1.4585 10.625 1.73832 10.625 2.0835V12.2411L12.0581 10.8082L12.1282 10.7477C12.3728 10.5662 12.7201 10.5863 12.9419 10.8082C13.186 11.0523 13.186 11.448 12.9419 11.6921L10.4419 14.1921L10.3718 14.2526C10.1272 14.4342 9.77995 14.414 9.55806 14.1921L7.05806 11.6921L6.99754 11.622C6.816 11.3773 6.83617 11.0301 7.05806 10.8082L7.12816 10.7477C7.37283 10.5662 7.72005 10.5863 7.94194 10.8082L9.375 12.2411ZM5.83333 6.04183C6.17851 6.04183 6.45833 6.32165 6.45833 6.66683C6.45833 6.98324 6.22321 7.24474 5.91814 7.28612L5.83333 7.29183H4.16667C3.62733 7.29183 3.18372 7.70172 3.13038 8.22699L3.125 8.3335V15.8335C3.125 16.3728 3.5349 16.8164 4.06016 16.8698L4.16667 16.8752H15.8333C16.3727 16.8752 16.8163 16.4653 16.8696 15.94L16.875 15.8335V8.3335C16.875 7.79416 16.4651 7.35055 15.9398 7.29721L15.8333 7.29183H14.1667C13.8215 7.29183 13.5417 7.01201 13.5417 6.66683C13.5417 6.35042 13.7768 6.08892 14.0819 6.04753L14.1667 6.04183H15.8333C17.0521 6.04183 18.0487 6.99325 18.1208 8.19389L18.125 8.3335V15.8335C18.125 17.0523 17.1736 18.0488 15.9729 18.121L15.8333 18.1252H4.16667C2.94789 18.1252 1.95133 17.1737 1.87918 15.9731L1.875 15.8335V8.3335C1.875 7.11472 2.82642 6.11816 4.02706 6.04601L4.16667 6.04183H5.83333Z" fill="white"/>
</svg>
</template>
  
<script>
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
svg {
  height: 18px;
}  
</style>
    
    